import CONFIG from "../config.js";

export const {
  BASE_URL,
  ASSESSMENT_URL,
  BROADCAST_URL,
  CONTENT_URL,
  CBMS_URL,
  GALILEO_API,
  COURSE_URL,
  WHITEBOARD_URL,
  LIVE_CLASS_URL,
} = CONFIG;

// export const BASE_URL = `http://172.16.2.29:4500/api/v1/`;
// export const BROADCAST_URL = `https://broadcast-validation.kneura.com`;
// export const BASE_URL = `https://server-validation.kneura.com/api/v1/`;
// export const ASSESSMENT_URL = `https://assessment-validation.kneura.com/api/v1/`;
// export const WHITEBOARD_URL = `https://val-flow.airmind.ai/`;
// export const LIVE_CLASS_URL = `https://liveclass-validation.kneura.com`;
// export const CBMS_URL = `https://runner-validation.kneura.com`;
// const GALILEO_API = `https://graph.kneura.com/g-api/`;
// const COURSE_URL = `https://graph.kneura.com/g-api/group/`;
// export const CONTENT_URL = `https://graph.kneura.com/`;
//const BASE_URL = `http://localhost:4500/api/v1/`;
// export const CONTENT_URL = `http://localhost:5000/`;
//export const ASSESSMENT_URL = `http://localhost:6090/api/v1/`;

// const GALILEO_API = `https://graph-validation.kneura.com/g-api/`;
// const COURSE_URL = `https://graph-validation.kneura.com/g-api/group/`;
// const GALILEO_API = `http://localhost:5000/g-api/`;
// const COURSE_URL = `http://localhost:5000/g-api/group/`;
// export const LIVE_CLASS_URL = 'https://bbb-dev.kneura.com';

export const STUDENT = {
  getStudentInfo: () => `${BASE_URL}student/studentInfo`,
  updateStudentInfo: () => `${BASE_URL}galileo/update/admin`,
  getStudentClass: () => `${BASE_URL}admin/class/getUserClasses`,
  getStudentProfile: () => `${BASE_URL}student/digitalMe/readStudentInfo`,
  setStudentProfile: () => `${BASE_URL}student/digitalMe/updateProfile`,
  fetchValidValues: () => `${BASE_URL}validValues/fetchValidValues`,
};

export const SIGNUP = {
  verifyRegisterCode: () => `${BASE_URL}galileo/user/verifyVid`,
  signUp: () => `${BASE_URL}student/signup`,
};

export const REGISTER_PROFILE = {
  registerProfile: (id) => `${BASE_URL}galileo/update/admin/${id}`,
};

export const LOGIN = {
  login: () => `${BASE_URL}galileo/login`,
  loginViaToken: (token) => `${BASE_URL}galileo/loginViaToken/${token}`,
};

export const IS_SESSION_ACTIVE = {
  isSessionActive: () => `${BASE_URL}galileo/isSessionActive`,
};

export const BBB = {
  getStudentURL: (whiteboardID) =>
    `${BASE_URL}bbb/getStudentURL/${localStorage.getItem(
      "kneuraId",
    )}/${whiteboardID}`,
};

export const FORGOT_PASSWORD = {
  sendRecoveryCode: () => `${BASE_URL}galileo/forgotPassword`,
  verifyRecoveryCode: () => `${BASE_URL}galileo/verifyResetCode`,
  resetPassword: () => `${BASE_URL}galileo/resetPassword`,
  changePassword: () => `${BASE_URL}galileo/changePassword`,
};
export const CLASSES = {
  createClass: (classInfo) =>
    `${BASE_URL}flow/addIWB?username=${classInfo.username}&user_id=${classInfo.user_id}&class_id=${classInfo.class_id}&name=${classInfo.name}`,
  fetchClass: (classid) =>
    `${BASE_URL}flow/getWhiteBoard?class_id=${classid}&role=learner`,
  getWhiteBoardInfo: (whiteboardID) =>
    `${BASE_URL}flow/getWhiteBoardInfo/${whiteboardID}`,
  getLiveBoards: (classId) =>
    `${BASE_URL}flow/lessonsAlreadyLiveWithName/${classId}`,
};
export const LOGOUT = {
  logout: () => `${BASE_URL}galileo/logout`,
};

export const COURSE = {
  getCourseDetail: () => `${COURSE_URL}get-my-groups`,
  getInfoByGroupId: (id, instituteId) =>
    `${COURSE_URL}get-info?group_id=${id}&institute_id=${instituteId}`,
  getBoardDetail: (id, instituteId) =>
    `${COURSE_URL}get-info?group_id=${id}&institute_id=${instituteId}`,
  getClassDetail: (id, instituteId) =>
    `${COURSE_URL}get-info?group_id=${id}&institute_id=${instituteId}`,
  getSubjectDetail: (id, instituteId) =>
    `${COURSE_URL}get-info?group_id=${id}&institute_id=${instituteId}`,
  getTopicDetail: (id, instituteId) =>
    `${COURSE_URL}get-info?group_id=${id}&institute_id=${instituteId}`,
  getAllTopics: () => `${GALILEO_API}topic/all-topics`,
  createGroup: () => `${COURSE_URL}create-custom`,
  createTopic: () => `${GALILEO_API}topic/create-custom`,
  createContent: () => `${GALILEO_API}content/create-custom`,
  createQuestion: () => `${GALILEO_API}question/create-custom`,
  cloneTopic: () => `${GALILEO_API}topic/clone-topic`,
};
export const ASSESSMENT = {
  createassessment: () => `${ASSESSMENT_URL}assessment/create`,
  getallassessment: (classId) =>
    `${ASSESSMENT_URL}assessment/fetch?classId=${classId}`,
};

export const QUESTIONS = {
  createQuestion: () => `${ASSESSMENT_URL}question/create`,
  fetchQuestions: (assessmentID) =>
    `${ASSESSMENT_URL}question/fetch?assessmentId=${assessmentID}`,
  readQuestion: (questionId) =>
    `${ASSESSMENT_URL}question/?questionId=${questionId}`,
  removeQuestion: () => `${ASSESSMENT_URL}question/remove`,
  updateCorrectOption: () => `${ASSESSMENT_URL}question/updateCorrectOption`,
  uploadQuestionImage: () => `${ASSESSMENT_URL}question/uploadImage`,
  updateQuestion: () => `${ASSESSMENT_URL}question/update`,
  duplicateQuestion: () => `${ASSESSMENT_URL}question/duplicate`,
  visitQuestion: () => `${ASSESSMENT_URL}questionResponse/visit`,
  updateQuestionOption: () => ` ${ASSESSMENT_URL}questionResponse/update`,
  markQuestion: () => `${ASSESSMENT_URL}questionResponse/mark`,
  getQuestionResponse: (assessmentResponseId, questionId) =>
    `${ASSESSMENT_URL}questionResponse/read?assessmentResponseId=${assessmentResponseId}&questionId=${questionId}`,
  submitAssessment: () => `${ASSESSMENT_URL}assessmentResponse/submit`,
};

export const NOTIFICATION = {
  getEndPoint: (notificationtoken) =>
    `${BROADCAST_URL}?token=${notificationtoken}`,
  getAllNotifications: (userId) =>
    `${BROADCAST_URL}/galileo/notification?receivers=${userId}`,
  deleteAllNotification: () => `${BROADCAST_URL}/galileo/notification/delete`,
};

export const GOOGLE_DRIVE = {
  fetch: () => `${BASE_URL}myFiles/fetch`,
};

export const LICENSE = {
  increment: () => `${BASE_URL}license/increment`,
};

export const LIVE_CLASS = {
  socket: () =>
    `${LIVE_CLASS_URL}/kneura?token=${localStorage.getItem(
      "usertoken",
    )}&flowID=${
      JSON.parse(sessionStorage.getItem("boardinfo")).flow_id
    }&device=WEB`,
};
export const MULTILINGUAL = {
  setLanguage: () => `${BASE_URL}admin/saveUserLanguage`,
  getLanguage: () => `${BASE_URL}admin/getUserLanguage`,
};

export const CBMS = {
  isCbmsEnabled: (sessionId) =>
    `${CBMS_URL}/runnerapi/v1/studentAnalytics/isCbmsEnabled?sessionId=${sessionId}`,
  saveAttendanceLog: () =>
    `${CBMS_URL}/runnerapi/v1/studentAnalytics/saveAttendanceLog`,
  getEndPoint: (cbmsToken) => `${CBMS_URL}?token=${cbmsToken}`,
  saveSessionVideo: () =>
    `${CBMS_URL}/runnerapi/v1/studentAnalytics/saveSessionVideo`,
};

export const SCHEDULER = {
  fetch: () => `${BASE_URL}scheduler/fetch`,
  create: () => `${BASE_URL}scheduler/create`,
  delete: (id) => `${BASE_URL}scheduler/delete/${id}`,
  update: () => `${BASE_URL}scheduler/update`,
};
